import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import classNames from 'classnames';

type Props = { className?: string };
export const TendersTotal: FC<Props> = ({ className }) => {
  const [{ data }] = useApiTenders();
  const { t } = useTranslation();

  const count = useMemo(() => data?.count, [data]);

  return (
    <>{!!count && <span className={classNames(styles.total, className)}>{t('Tenders.totalMatch', { count })}</span>}</>
  );
};

export default TendersTotal;
